import { CardTitle } from '@/components/atoms/Card';

type Props = {
  title: React.ReactNode;
  className?: string;
};

export function MetricCardTitle({ title, className }: Props) {
  return <CardTitle className={className}>{title}</CardTitle>;
}

MetricCardTitle.displayName = 'MetricCardTitle';
